import React from 'react';
import Left_bg from '../../../assets/Group 11635.png';
import vibe_logo from '../../../assets/vibe-logo.png';
import app_store from '../../../assets/app_store.png';
import google_play from '../../../assets/google_play.png';

const DownloadApp = () => {
    return (
        <div className='download-app'>
            <div className='download-app-container'>
                <div className='inner-download-app'>
                    {/* <div className='inner-download-app-logo'>
                        <img src={vibe_logo} alt="" />
                    </div> */}
                    <h1>Download <br />Application Now</h1>
                    <div className='inner-download-app-button'>
                        <div>
                            <a href="https://play.google.com/store/apps/details?id=com.vibe_app&pcampaignid=web_share" target="_blank" rel="noopener noreferrer">
                                <img src={google_play} alt="Get it on Google Play" />
                            </a>
                        </div>
                        <div>
                            <a href="https://apps.apple.com/pk/app/vibe-pso/id6503432941" target="_blank" rel="noopener noreferrer">
                                <img src={app_store} alt="Download on the App Store" />
                            </a>
                        </div>
                    </div>
                </div>
                <div className='inner_download_app_banner_div'>
                    <img src={Left_bg} alt="" />
                </div>
            </div>
        </div>
    )
}

export default DownloadApp